import classes from "./AsideMob.module.scss";
import { useEffect, useState, useContext } from "react";
import cart from "./../../../../../assets/images/cart.svg";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import arrowLeft from "./../../../../../assets/images/arrow_left.svg";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import CardBase from "../../../../UI/Card/CardBase/CardBase";
import SystemContext from "../../../../../context/SystemContext";
import checkPayment from "../../../../../assets/images/check_payment.svg";
import AccordionAfinando from "../../../../UI/AccordionAfinando/AccordionAfinando";

const AsideMob = ({ BuyPlan, UpdateUserInfo, Products , PaymentMethod , instantPay}) => {
  const payload = useSelector((state) => state.purchase);

  const { CheckError, setCheckError, setOpenModalWaitPayment, errorRule, setErrorRule,changePropertyUrl } =
    useContext(SystemContext);

  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [PlanName, setPlanName] = useState();
  const [Periodicity, setPeriodicity] = useState();
  const [AccordionMob, setAccordionMob] = useState(false);

  const [ButtonsArea, setButtonsArea] = useState({
    Top: {
      content: "",
      step: "",
      show: true,
      checked: true,
      func: false,
      name: "",
    },
    Back: {
      content: "",
      step: "",
      show: true,
    },
    Link: {
      content: "",
      step: "",
      show: false,
      name: "",
    },
    PaymentInfo: false,
  });
  const [isLoadingUserInfo, setIsLoadingUserInfo] = useState(false);

  const handleChange = () => (event, newExpanded) => {
    setAccordionMob(newExpanded ? true : false);
  };

  useEffect(() => {
    if (payload && payload.purchase && payload.purchase.step) {
      const map_payload = {
        "InvoiceData": () => {
          return {
            Top: {
              content: "PaymentArea",
              step: PaymentMethod && PaymentMethod == "pix" ? "DescPix" : "CreditCard",
              show: true,
              checked: CheckError.invoiceData,
              func: false,
              funcCall: async () => {
                return new Promise((resolve, reject) => {
                  UpdateUserInfo(resolve, reject);
                });
              },
              name: t("purchase.continue"),
            },
            Back: {
              content: payload.planInfo.content,
              step: payload.planInfo.step,
              show: true,
              funcCall: async (content="") => {
                changePropertyUrl((content)?-1:0)
              }
            },
            PaymentInfo: true,
          }
        },
        "CreditCard": () => {
          return {
            Top: {
              content: "ChoosePlan",
              step: "OpenSpinner",
              show: true,
              checked: errorRule?.checkbox,
              func: true,
              name: (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                    fontWeight: "bold",
                    gap: "15px",
                  }}
                >
                  <div>{t("purchase.finish")}</div>
                  <img
                    style={{ width: "16px" }}
                    src={checkPayment}
                    alt={t("purchase.left_arrow")}
                  />
                </div>
              )
            }
          }
        },
        "PaymentError": () => {
          return {
            Top: {
              show: false,
              checked: true,
              func: false,
            },
            Back: {
              show: false,
            },
          }
        },
        "DescPix": () => {
          return {
            Top: {
              content: "ChoosePlan",
              step: "OpenSpinner",
              show: true,
              checked: CheckError.pix,
              func: true,
              name: (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                    fontWeight: "bold",
                    gap: "15px",
                  }}
                >
                  <div>finalizar</div>
                  <img
                    style={{ width: "16px" }}
                    src={checkPayment}
                    alt={t("purchase.left_arrow")}
                  />
                </div>
              ),
            },
            Back: {
              content: "PaymentArea",
              step: "InvoiceData",
              show: true,
            },
          }
        },
        "PixQrCode": () => {
          return {
            Top: {
              content: "PurchaseSuccess",
              step: "PurchaseSuccess",
              show: true,
              checked: payload.planInfo.pixIsPaid,
              func: false,
              name: t("purchase.i_already_made_my_payment"),
            },
            Back: {
              content: "PaymentArea",
              step: "DescPix",
              show: true,
            },
          }
        },
        "RenewPlan": () => {
          return {
            Top: {
              content: "PaymentArea",
              step: "InvoiceData",
              show: true,
              checked: true,
              func: false,
              name: t("purchase.renew_plan"),
            },
            Back: {
              show: false,
            },
            Link: {
              content: "ChoosePlan",
              step: "SelectPlan",
              show: true,
            },
          }
        }
      }
      if (payload.purchase.step in map_payload)
        setButtonsArea((prevState) => ({ ...prevState, ...map_payload[payload.purchase.step]() }));

      if (payload.PostData) {
        if (payload.PostData.periodicity) {

          const map_periodicity = {
            "monthly": () => {
              setPeriodicity(t("purchase.monthly"));
            },
            "annual": () => {
              setPeriodicity(t("purchase.annual"));
            },
            "lifetime": () => {
              setPeriodicity("");
            },
          }

          if (payload.PostData.periodicity in map_periodicity)
            map_periodicity[payload.PostData.periodicity]();
        }

        // if (payload.PostData.product_id) {
        //   const name = getNameById(payload.PostData.product_id[0]);
        //   setPlanName(name);
        //   const description = getDescByName(name);

        //   dispatch({
        //     type: "PURCHASE",
        //     planInfo: {
        //       planName: name,
        //       planDescription: description,
        //     },
        //   });
        // }
      }


    }
  }, [Products, payload, CheckError]);


  // const getNameById = (id_product) => {
  //   const foundItem = Products?.periodicity.find(
  //     (item) => item.id_product === id_product
  //   );
  //   return foundItem ? foundItem.name : null;
  // };
  // const getDescByName = (name_product) => {
  //   const foundItem = Products?.periodicity.find(
  //     (item) => item.name === name_product
  //   );
  //   return foundItem ? foundItem.description.product_descriptions : null;
  // };


  const TopButton = async () => {
    setIsLoadingUserInfo(true);
    if (ButtonsArea.Top.hasOwnProperty("funcCall") && ButtonsArea.Top.funcCall) {
      try {
        await ButtonsArea.Top.funcCall();
      } catch (e) {
        console.log("Error occurred while calling Top button function:", e);
        setIsLoadingUserInfo(false);
        return;
      }
    }
    ButtonsArea.Top.checked &&
      dispatch({
        type: "PURCHASE",
        purchase: {
          content: ButtonsArea.Top.content,
          step: ButtonsArea.Top.step,
        },
      });
    ButtonsArea.Top.func && ButtonsArea.Top.checked && BuyPlan();
    setCheckError((prevState) => ({
      ...prevState,
      invoiceShowError: true,
      creditCardShowError: true,
    }));
    payload.purchase.step === "PixQrCode" && setOpenModalWaitPayment(true);
    // payload.purchase.step === "CreditCard" &&
    //   setErrorRule((prevState) => ({
    //     ...prevState,
    //     checkbox: true,
    //   }));
    setIsLoadingUserInfo(false);
  };

  const back = () => {
    if (ButtonsArea.Back.hasOwnProperty("funcCall") && ButtonsArea.Back.funcCall) {

      try{
        ButtonsArea.Back.funcCall(ButtonsArea.Back.content);
      }catch(e){
        console.log("Error occurred while calling Back button function:", e);
        //setIsLoadingUserInfo(false);
        //return
      }
    }
    if (instantPay && payload.purchase.step === "InvoiceData") {
      global.window.location.href = "/painel";
    }
    dispatch({
      type: "PURCHASE",
      purchase: {
        content: ButtonsArea.Back.content,
        step: ButtonsArea.Back.step,
      },
    });
  };

  const GoToSelectPlan = () => {
    dispatch({
      type: "PURCHASE",
      purchase: {
        content: ButtonsArea.Link.content,
        step: ButtonsArea.Link.step,
      },
    });
  };

  const theme = createTheme({
    palette: {
      ochre: {
        main: "#662D91",
        light: "#662D91",
        dark: "#430d6c",
        contrastText: "#FFF",
      },
      ochreBack: {
        main: "#FFF",
        light: "#FFF",
        contrastText: "#787676",
      },
    },
  });

  return (
    <aside className={classes.AsideMob}>
      {ButtonsArea.PaymentInfo && (
        <AccordionAfinando
          transitionDelay={400}
          expanded={AccordionMob}
          onChange={handleChange()}
          classPrimary={classes.AsideMobAccordion}
          title={
            <div className={classes.TitleArea}>
              <div className={classes.PlanName}>
                <div>{t("purchase.chosen_plan")}</div>
                <div>{payload.planInfo?.planName}</div>
              </div>
              <div className={classes.ValueArea}>
                <div>{t("purchase.total")}</div>
                <div>{`${payload.planInfo.value} ${Periodicity}`}</div>
              </div>
            </div>
          }
          description={
            payload.planInfo.planDescription &&
            <CardBase classPrimary={classes.CardBase}>
              {payload.planInfo.planDescription?.map((item, index) => (
                <Typography key={index} className={classes.PlanCardDesc}>
                  {item}
                </Typography>
              ))}
            </CardBase>
          }
        />
      )}
      <ThemeProvider theme={theme} >
        <div className={classes.ButtonsArea}>
          {ButtonsArea.Top.show && (
            <Button onClick={TopButton} variant="contained" color="ochre" disabled={isLoadingUserInfo || !ButtonsArea.Top.checked}>
              {ButtonsArea.Top.name}
            </Button>
          )}
          {ButtonsArea.Back.show && (
            <Button onClick={back} style={{ width: "100%", fontWeight: "bold", gap: "15px" }}
              variant="contained"
              disabled={isLoadingUserInfo}
              color="ochreBack"
            >
              {t("purchase.return")}
            </Button>
          )}
          {ButtonsArea.Link.show && (
            <button onClick={GoToSelectPlan} className={classes.Link}>
              {t("purchase.i_want_to_choose_another_plan")}
            </button>
          )}
        </div>
      </ThemeProvider>
    </aside>
  );
};
export default AsideMob;
